export const ROUTES = {
  overview: '/overview',
  receptionist: '/receptionist',
  knowledge: '/knowledge',
  integrations: '/integrations',
  calls: '/calls',
  organization: '/organization',
  operations: '/operations',
  help: '/help',
  pricing: '/pricing',
};

export const LEGACY_ROUTE_REDIRECTS = [
  { from: '/dashboard', to: ROUTES.overview },
  { from: '/customize-ai', to: ROUTES.receptionist, oauthTo: ROUTES.integrations },
  { from: '/knowledge-base', to: ROUTES.knowledge },
  { from: '/transcripts', to: ROUTES.calls },
  { from: '/plans', to: ROUTES.pricing },
  { from: '/faq', to: ROUTES.help },
  { from: '/admin', to: ROUTES.operations },
];

export const APP_NAV_ITEMS = [
  { label: 'Overview', path: ROUTES.overview, icon: 'overview', group: 'Workspace' },
  { label: 'Receptionist', path: ROUTES.receptionist, icon: 'sparkles', group: 'Workspace' },
  { label: 'Knowledge', path: ROUTES.knowledge, icon: 'knowledge', group: 'Workspace' },
  { label: 'Integrations', path: ROUTES.integrations, icon: 'integrations', group: 'Operations' },
  { label: 'Calls', path: ROUTES.calls, icon: 'calls', group: 'Operations' },
  { label: 'Organization', path: ROUTES.organization, icon: 'organization', group: 'Manage' },
];

export const PUBLIC_NAV_ITEMS = [
  { label: 'Home', path: '/' },
  { label: 'Pricing', path: ROUTES.pricing },
  { label: 'Help', path: ROUTES.help },
];

export function getAppPage(pathname) {
  if (pathname.startsWith(ROUTES.operations)) return { label: 'Operations', icon: 'admin' };
  if (pathname.startsWith('/updates')) return { label: 'Updates', icon: 'updates' };
  if (pathname.startsWith('/account')) return { label: 'Account', icon: 'organization' };
  return APP_NAV_ITEMS.find((item) => pathname.startsWith(item.path)) || APP_NAV_ITEMS[0];
}

export function NavigationIcon({ name, size = 20 }) {
  const props = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  };

  const paths = {
    overview: <><rect x="3" y="3" width="7" height="7" rx="2" /><rect x="14" y="3" width="7" height="7" rx="2" /><rect x="3" y="14" width="7" height="7" rx="2" /><rect x="14" y="14" width="7" height="7" rx="2" /></>,
    sparkles: <><path d="m12 3 1.25 3.75L17 8l-3.75 1.25L12 13l-1.25-3.75L7 8l3.75-1.25L12 3Z" /><path d="m18.5 14 .75 2.25L21.5 17l-2.25.75L18.5 20l-.75-2.25L15.5 17l2.25-.75L18.5 14Z" /><path d="M5 13v8M1 17h8" /></>,
    knowledge: <><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H11v16H6.5A2.5 2.5 0 0 0 4 21.5v-16Z" /><path d="M20 5.5A2.5 2.5 0 0 0 17.5 3H13v16h4.5a2.5 2.5 0 0 1 2.5 2.5v-16Z" /></>,
    integrations: <><path d="M8 3v4M16 3v4M6 7h12v3a6 6 0 0 1-12 0V7Z" /><path d="M12 16v5M9 21h6" /></>,
    calls: <><path d="M7.3 3H4.8A1.8 1.8 0 0 0 3 4.8C3 13.75 10.25 21 19.2 21a1.8 1.8 0 0 0 1.8-1.8v-2.5l-4.4-1.1-1.1 2.2a13.6 13.6 0 0 1-9.3-9.3l2.2-1.1L7.3 3Z" /></>,
    organization: <><path d="M3 21h18M5 21V7l7-4 7 4v14" /><path d="M9 10h.01M15 10h.01M9 14h.01M15 14h.01M10 21v-4h4v4" /></>,
    admin: <><path d="M12 3 4 7v5c0 5 3.4 8.2 8 9 4.6-.8 8-4 8-9V7l-8-4Z" /><path d="m9 12 2 2 4-4" /></>,
    observability: <><path d="M3 12h4l2-6 4 12 2-6h6" /><path d="M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" /></>,
    cleanup: <><path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13" /><path d="M10 11v5M14 11v5" /><path d="M18.5 3.5 20 5l-1.5 1.5L17 5l1.5-1.5Z" /></>,
    invite: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m4 7 8 6 8-6" /><path d="M17 3v4M15 5h4" /></>,
    help: <><circle cx="12" cy="12" r="9" /><path d="M9.5 9a2.6 2.6 0 1 1 4.1 2.1c-1 .7-1.6 1.1-1.6 2.4" /><path d="M12 17h.01" /></>,
    menu: <><path d="M4 7h16M4 12h16M4 17h16" /></>,
    close: <><path d="m6 6 12 12M18 6 6 18" /></>,
    updates: <><path d="M12 3v18M3 12h18" /></>,
  };

  return <svg {...props}>{paths[name] || paths.overview}</svg>;
}
